import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/AboutUs.css";

const AboutUs = () => {


  const navigate = useNavigate();

  return (
    <>
      {/* HeroSection */}
      <section
        className="hero-section position-relative d-flex justify-content-center align-items-center text-center text-md-start"
        style={{
          height: "40vh",
          // paddingTop: "70px",
          color: "white",
        }}
      >
        <div
          className="blurred-bg position-absolute w-100 h-100"
          style={{
            backgroundImage: "url('/images/unsplash1.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            top: 0,
            left: 0,
            zIndex: 0,
            transform: "scale(1.05)",
          }}
        >
        </div>
        <div
          className="position-relative px-3 d-flex flex-column justify-content-center"
          style={{
            zIndex: 1,
            maxWidth: "700px",
            width: "100%",
          }}
        >
          <h1 className="fw-bold text-white banner-heading mb-2 text-wrap text-center">
            Jharkhand Tourism Development Corporation Ltd.
          </h1>

          <p className="lead text-white banner-subtitle text-center">
            Promoting Heritage & Hospitality
          </p>
        </div>
      </section>

      {/* AboutIntro */}
      <section className="about-intro-section mt-md-25 px-0 px-md-5 py-0 py-md-3">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h2 className="section-title text-center m-3">About JTDC</h2>
              <p className="text-black-50 mb-4 small">
                The Jharkhand Tourism Development Corporation (JTDC) was established on March 22, 2002, with a clear mission: to strengthen tourism in Jharkhand and open new avenues for economic growth and local employment. As a state-owned body, JTDC plays a key role in bringing Jharkhand’s natural beauty, culture, and heritage to a wider audience both within India and beyond.
              </p>
              <p className="text-black-50 mb-4 small">
                Operating under the framework of the Jharkhand Tourism Policy 2021, JTDC is committed to building a sustainable, traveller-friendly ecosystem. It focuses on improving infrastructure, promoting eco-tourism, and preserving the state’s unique cultural identity all while placing hospitality at the centre of the travel experience.
              </p>
              <p className="text-black-50 mb-4 small">
                What makes Jharkhand stand out isn't just its breathtaking natural beauty though the serene climate, deep forests, majestic waterfalls, and wildlife sanctuaries are reason enough to visit. It's the state’s authentic spirit its tribal heritage, spiritual landmarks, indigenous festivals, and warm, grounded people. JTDC’s hospitality brings these intangible qualities to life.
              </p>
              <p className="text-black-50 mb-4 small">
                Across the state, JTDC runs a network of government-owned hotels, resorts, and guesthouses, each one designed to provide more than just a place to stay. These properties are built to reflect Jharkhand’s ethos welcoming, responsible, and deeply local. Whether it's a deluxe property near Netarhat, a lakeside resort in Patratu, or a hotel near Deoghar, the focus remains the same: offer comfort without compromise, and authenticity without dilution.
              </p>
              <p className="text-black-50 mb-4 small">
                Every JTDC property supports local employment, champions eco-friendly practices, and prioritizes a guest-first mindset. Staff are trained not just in service, but in hospitality that honours the land from the food you’re served to the stories you hear. It’s about giving every guest not just a room, but a reason to return.
              </p>
              <p className="text-black-50 mb-4 small">
                At its core, JTDC is building a hospitality model that’s inclusive, sustainable, and emotionally resonant a model where guests feel welcomed, and Jharkhand feels unforgettable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ServiceHighlights */}
      <section className="highlights-section py-5 px-3 px-md-5">
        <div className="container">
          <div className="row justify-content-center">
            {[
              {
                title: "Hotels",
                description:
                  "Relax in JTDC hotels with modern amenities, scenic views, and local hospitality across Jharkhand’s most iconic destinations.",
              },
              {
                title: "TIC",
                description:
                  "Tourist Information Centres offer expert guidance, cultural tips, and travel support to help you explore Jharkhand like a local.",
              },
              {
                title: "Restaurant",
                description:
                  "Enjoy authentic tribal and regional dishes made with local ingredients, celebrating the rich culinary heritage of Jharkhand.",
              },
              {
                title: "Green Escape",
                description:
                  "Reconnect with nature through eco-friendly stays, forest trails, and serene getaways curated by Jharkhand Tourism’s Green Escape initiative.",
              },
            ].map((item, index) => (
              <div
                className="col-12 col-sm-6 col-lg-3 mb-4"
                key={index}

              >
                <div className="highlight-card p-4 h-100">
                  <h4 className="fw-bold mb-2">{item.title}</h4>
                  <p className="small mb-0">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VisualBanner */}
      <section className="visual-banner-section">
        <div className="visual-banner-wrapper">
          <img
            src="/images/DSC_4032.jpg"
            alt="Scenic Jharkhand"
            className="img-fluid w-100 visual-banner-image"
          />
        </div>
      </section>

      {/* WhatWeDo */}
      <section className="what-we-do-section py-5 mt-25 px-3 px-md-5">
        <div className="container">
          <h2 className="section-title text-center mb-2 mt-1">Experiences That Go Further</h2>
          <p className="lead-text text-center mb-5" style={{ maxWidth: "720px", margin: "0 auto", color: "black" }}>
            Beyond our resort offerings, we showcase restaurants in key locations...
          </p>
          <div className="row">
            {[
              {
                title: "Eco-Friendly Living",
                icon: "/images/leaf-solid.svg",
                description: "Revenue from our hotels supports guest comfort and nature preservation—ensuring responsible tourism and greener surroundings for future generations.",
              },
              {
                title: "Community Growth",
                icon: "/images/face-smile-solid.svg",
                description: "Our resorts empower local communities by generating employment, promoting self-reliance, and encouraging sustainable, eco-conscious living across Jharkhand.",
              },
              {
                title: "Unmatched Hospitality",
                icon: "/images/archway-solid.svg",
                description: "Experience seamless stays with heartfelt service and diverse menus featuring authentic Jharkhandi flavours at every JTDC property.",
              },
              {
                title: "Preserving Heritage",
                icon: "/images/vihara-solid.svg",
                description: "We celebrate tribal roots through cultural cuisine, music, and art—preserving Jharkhand’s living heritage with every guest interaction.",
              },
            ].map((item, index) => (
              <div
                className="col-12 col-md-6 col-lg-3 mb-4"
                key={index}
              >
                <div className="what-we-do-card h-100 p-4 mt-20 text-center">
                  <img src={item.icon} alt={item.title} className="mb-3 what-we-do-icon" />
                  <h5 className="mb-3">{item.title}</h5>
                  <p className="small">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TestimonialStrip */}
      <section className="testimonial-strip-section py-5 mt-25 px-3 px-md-5">
        <div className="container">
          <h2 className="section-title text-center mb-4 mt-2">What Our Guests Say</h2>
          <div className="row justify-content-center">
            {[
              {
                quote: "JTDC’s hospitality made my trip unforgettable. The serene environment and warm welcome felt like home.",
                author: "Anita Sharma",
                designation: "Travel Blogger",
              },
              {
                quote: "The eco-friendly resorts truly care about nature and community. A perfect getaway with a conscience.",
                author: "Rohit Verma",
                designation: "Environmentalist",
              },
              {
                quote: "Authentic local cuisine and vibrant cultural experiences made our stay one of the best.",
                author: "Sunita Das",
                designation: "Food Enthusiast",
              },
            ].map((item, index) => (
              <div
                className="col-12 col-md-8 col-lg-6 mb-4"
                key={index}

              >
                <div className="testimonial-card p-4 rounded shadow-sm">
                  <p className="testimonial-quote fst-italic">“{item.quote}”</p>
                  <p className="testimonial-author fw-bold mt-3 mb-0">{item.author}</p>
                  <p className="testimonial-designation mb-0">{item.designation}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="title-underline mx-auto m-3"></div>

      {/* InfoPage / NavigationButtons */}
      <section className="info-page-section py-5 px-3 px-md-5">
        <div className="container text-center">

          {/* Section Title */}
          <div className="section-header mb-2">
            <h3 className="section-title mt-2">
              Explore Our Services
            </h3>
          </div>

          {/* Subtitle */}
          <p className="mb-4 text-muted">
            Discover more about our services and governance to help you plan better.
          </p>

          {/* Navigation Buttons */}
          <div className="nav-buttons d-flex justify-content-center gap-4 flex-wrap">
            <button
              type="button"
              className="btn explore-btn d-flex align-items-center"
              onClick={() => navigate("/allhotel")}
              aria-label="Navigate to Hotels Page"
              style={{ gap: "8px" }}
            >
              <img
                src="/images/hotel-svgrepo-com.svg"
                alt="Hotels"
                className="hotel-icon"
                style={{ width: "24px", height: "24px" }}
              />
              Hotels
            </button>

            <button
              type="button"
              className="btn explore-btn d-flex align-items-center"
              onClick={() => navigate("/organizational-structure")}
              aria-label="Navigate to Organizational Structure"
              style={{ gap: "8px" }}
            >
              <img
                src="/images/organization-network-management-svgrepo-com.svg"
                alt="Structure & Governance"
                className="hotel-icon text"
                style={{ width: "24px", height: "24px" }}
              />
              Structure & Governance
            </button>
          </div>
        </div>
      </section>

    </>
  );
};

export default AboutUs;
